import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import moment from "moment";
import isString = require("lodash/isString");
import Calendar from 'react-widgets/lib/Calendar';
import {Overlay, Popover} from "react-bootstrap";
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {fieldStyles} from 'core/form/createForm';
import {findOverlayPlacement} from "core/common/utils/domUtils";
import {formatInterval} from "core/common/utils/dateUtils";
import {PropsObjectType} from "core/form/form";


interface StyledDateIntervalProps extends PropsObjectType {
  valueFrom?: any;
  valueTo?: any;
  oldValueFrom?: any;
  oldValueTo?: any;
  onChangeFrom: React.ReactEventHandler<any>;
  onChangeTo: React.ReactEventHandler<any>;
}


interface StyledDateIntervalState {
  focused?: boolean,
  showPopover?: boolean;
  localValueFrom?: any;
  localValueTo?: any;
  valueStr?: string;
  target?: Function;
  overlayPlacement?: any;
}

export default class StyledDateInterval extends React.PureComponent<StyledDateIntervalProps, StyledDateIntervalState> {



  state: StyledDateIntervalState = {
    focused: false,
    showPopover: false,
    localValueFrom: null,
    localValueTo: null,
    valueStr: null,
    overlayPlacement: null
  };


  onChangeFromWrapper(value) {
    this.props.onChangeFrom( (value instanceof Date) ? moment(value).format("YYYY-MM-DD") : value );
  }

  onChangeToWrapper(value) {
    this.props.onChangeTo( (value instanceof Date) ? moment(value).format("YYYY-MM-DD") : value );
  }


  parseInterval(valueStr) {
    if (!valueStr) return [null, null];

    let pole = valueStr.split('-');
    let validFromStr = pole[0].trim();
    let validToStr = (pole.length >= 2) ? pole[1].trim() : null;

    if (validFromStr === '\u221E') validFromStr = null;
    if (validToStr === '\u221E') validToStr = null;

    let validFrom: any = (validFromStr) ? moment(validFromStr, "L") : null;
    let validTo: any = (validToStr) ? moment(validToStr, "L") : null;

    validFrom = (validFrom && validFrom.isValid()) ? validFrom.toDate() : null;
    validTo = (validTo && validTo.isValid()) ? validTo.toDate() : null;

    return  [validFrom, validTo];
  }


  componentWillMount() {
    let {valueFrom, valueTo} = this.props;
    console.log('componentWillMount');
    this.setState({
      localValueFrom: (valueFrom) ? moment(valueFrom).toDate() : null,
      localValueTo: (valueTo) ? moment(valueTo).toDate() : null,
      valueStr: formatInterval(valueFrom, valueTo)
    });
  }

  componentWillReceiveProps(nextProps) {
    let {valueFrom, valueTo} = nextProps;
    let {oldValueFrom, oldValueTo} = this.props;
    if (valueFrom !== oldValueFrom || valueTo !== oldValueTo) {
      this.setState({
        localValueFrom: (valueFrom) ? moment(valueFrom).toDate() : null,
        localValueTo: (valueTo) ? moment(valueTo).toDate() : null,
        valueStr: formatInterval(valueFrom, valueTo)
      });
    }
  }


  onBlur = (e) => {
    console.log('onBlur: %O', e);
    let {localValueFrom, localValueTo} = this.state;

    this.setState({
      focused: false
    });

    this.onChangeFromWrapper(localValueFrom);
    this.onChangeToWrapper(localValueTo);
  };



  onFocus = (e) => {
    this.setState({
      focused: true,
      showPopover: true,
      target: e.target,
      overlayPlacement: findOverlayPlacement(e.target, 550, 450)
    });
  };


  ok = (e) => {
    let {localValueFrom, localValueTo} = this.state;

    this.onChangeFromWrapper(localValueFrom);
    this.onChangeToWrapper(localValueTo);

    this.setState({showPopover: false});
  };

  cancel = (e) => {
    let {valueFrom, valueTo} = this.props;
    this.setState({
      showPopover: false,
      localValueFrom: (isString(valueFrom)) ? moment(valueFrom).toDate() : valueFrom,
      localValueTo: (isString(valueTo)) ? moment(valueTo).toDate() : valueTo,
      valueStr: formatInterval(valueFrom, valueTo)
    });
  };




  onChangeText = (e) => {
    let _valueStr = e.target.value;

    let [v1, v2] = this.parseInterval(_valueStr);

    console.log('onChange(), setting state valueStr = %s', _valueStr);
    this.setState({
      localValueFrom: v1,
      localValueTo: v2,
      valueStr: _valueStr
    });
  };

  onChangeFromLocal = (value) => {
    this.setState({
      localValueFrom: value,
      valueStr: formatInterval(value, this.state.localValueTo)
    });
  };
  onChangeToLocal = (value) => {
    this.setState({
      localValueTo: value,
      valueStr: formatInterval(this.state.localValueFrom, value)
    });
  };

  toPreviousMonth = (e) => {
    let _from = moment().subtract(1, 'months').startOf('month').toDate(),
      _to = moment().subtract(1, 'months').endOf('month').startOf('day').toDate();

    this.setState({
      localValueFrom: _from,
      localValueTo: _to,
      valueStr: formatInterval(_from, _to)
    });
  };

  toThisMonth = (e) => {
    let _from = moment().startOf('month').toDate(),
      _to = moment().endOf('month').startOf('day').toDate();

    this.setState({
      localValueFrom: _from,
      localValueTo: _to,
      valueStr: formatInterval(_from, _to)
    });
  };

  toNextMonth = (e) => {
    let _from = moment().add(1, 'months').startOf('month').toDate(),
      _to = moment().add(1, 'months').endOf('month').startOf('day').toDate();

    this.setState({
      localValueFrom: _from,
      localValueTo: _to,
      valueStr: formatInterval(_from, _to)
    });
  };

  toThisYear = (e) => {
    let _from = moment().startOf('year').toDate(),
      _to = moment().endOf('year').startOf('day').toDate();

    this.setState({
      localValueFrom: _from,
      localValueTo: _to,
      valueStr: formatInterval(_from, _to)
    });
  };

  toNextYear = (e) => {
    let _from = moment().add(1, 'years').startOf('year').toDate(),
      _to = moment().add(1, 'years').endOf('year').startOf('day').toDate();

    this.setState({
      localValueFrom: _from,
      localValueTo: _to,
      valueStr: formatInterval(_from, _to)
    });
  };


  render() {

    let {
      valueFrom,
      valueTo,
      onChangeFrom,
      onChangeTo,
      style,
      onBlur,
      onFocus,
      onChange,
      ...other
    } = this.props;

    let {
      localValueFrom,
      localValueTo,
      valueStr,
      overlayPlacement
    } = this.state;


    const calendarStyle = { maxWidth: 230, margin: 10, border: 0};
    const inputWrapperStyle = { padding: "0 10px"};
    const buttonPeriodStyle = { fontSize: 16};
    const buttonActionStyle = { margin: "0 10px"};

    const popoverBottom = (
      <Overlay
        show={this.state.showPopover}
        onHide={this.cancel}
        target={this.state.target}
        placement={overlayPlacement}
      >
        <Popover id="popover-positioned-bottom">

          <div style={{display: 'flex'}}>
            <FlatButton style={buttonPeriodStyle} label="Previous Month" secondary={true} onClick={this.toPreviousMonth}/>
            <FlatButton style={buttonPeriodStyle} label="This Month" secondary={true} onClick={this.toThisMonth}/>
            <FlatButton style={buttonPeriodStyle} label="Next Month" secondary={true} onClick={this.toNextMonth}/>
            <FlatButton style={buttonPeriodStyle} label="This year" secondary={true} onClick={this.toThisYear}/>
            <FlatButton style={buttonPeriodStyle} label="Next year" secondary={true} onClick={this.toNextYear}/>
          </div>

          <div style={{display: 'flex'}}>
            <div>
              <div style={inputWrapperStyle}>
                <StyledDatePicker value={localValueFrom} onChange={this.onChangeFromLocal} hideCalendar {...fieldStyles.small.textField} />
              </div>
              <Calendar value={localValueFrom} onChange={this.onChangeFromLocal} style={calendarStyle} />
            </div>
            <div>
              <div style={inputWrapperStyle}>
                <StyledDatePicker value={localValueTo} onChange={this.onChangeToLocal} hideCalendar {...fieldStyles.small.textField} />
              </div>
              <Calendar value={localValueTo} onChange={this.onChangeToLocal} style={calendarStyle} />
            </div>
          </div>

          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <RaisedButton onClick={this.ok} label="Ok" primary={true} style={buttonActionStyle}/>
            <RaisedButton onClick={this.cancel} label="Cancel" primary={true} style={buttonActionStyle}/>
          </div>


        </Popover>
        </Overlay>
    );

    return (
      <div>
        <MdTextField {...other} value={valueStr} onChange={this.onChangeText} onBlur={this.onBlur} onFocus={this.onFocus}  {...fieldStyles.small.textField} />
        {popoverBottom}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/components/fields/styledDateInterval.tsx